import { render } from "./Range.vue?vue&type=template&id=9cb6fe1a"
import script from "./Range.vue?vue&type=script&lang=js"
export * from "./Range.vue?vue&type=script&lang=js"
script.render = render

export default script